<template>
	<div class="result-app">
		<!-- answer -->
		<div class="answer-box">
			<div class="answer-box-left">
				<div class="result-title">
					<!--nav-->
					<div class="detail-nav" v-if="this.cate_id==0">
						<router-link to="/">
							<img src="images/index.png" />首页
						</router-link>
						<router-link to="/">{{category_name}}</router-link>
						<router-link to="/">{{chapter}}</router-link>
						<span>{{chapter_sub}}</span>
					</div>
					<div class="detail-nav" v-else>
						<router-link to="/">
							<img src="images/index.png" />首页
						</router-link>
						<span>随机练习</span>
					</div>
					<dl>
						<dt>{{chapter_sub}}</dt>
						<dd>
							<span>交卷时间：{{data.create_time*1000|formatDate}}</span>
							<span>答题用时：{{data.reply_time|forsecondDate}}</span>
							<span>平均答题用时：{{data.avg|forsecondDate}}</span>
						</dd>
						<div class="result-title-num">
							<b>{{data.res_score}}</b>分
						</div>
					</dl>
				</div>

				<div class="result-box">
					<div class="result-nav">
						<p :class="{active:tabActive == '1'}" @click="tabSlide(1)">错题解析</p>
						<p :class="{active:tabActive == '2'}" @click="tabSlide(2)">试题解析</p>
						<button @click="showQueWin = true">
							<img src="/images/an_12.png" alt />加入答疑QQ群
						</button>
						<el-dialog :visible.sync="showQueWin" width="400px">
							<div class="win-que">
								<img src="/images/an_11.png" alt />
								<div>
									<img src="https://www.sz517.com/static/home/images/dyh.jpg" alt />
								</div>扫二维码加入答疑QQ群
							</div>
						</el-dialog>
					</div>

					<div class="result-test">
						<!-- 题目 -->
						<!-- 	<div class="answer-que"
							:class="{'answer-gap':fillInTheBlankQuestionType.includes(item.genre),'answer-title-img':item.icon}"
							v-for="(item,index) in parsing" :key="index" v-show="item.res==0 || tabActive==2"
							:id="'answer'+(index+1)"> -->
						<div class="answer-que" v-for="(item,index) in answerList" :key="index">
							<div class="answer-que-title">
								<xmp v-if="!(fillInTheBlankQuestionType.includes(item.genre))" class="result-xmp">
									{{index+1}}、【{{item.genre_type}}】{{item.text?item.text:item.title}}
								</xmp>
								<aside v-else v-html="index+1+'、'+'【'+item.genre_type+'】'+item.title"
									class="result-xmp">
									{{index+1}}、【{{item.genre_type}}】{{item.text?item.text:item.title}}
								</aside>
								<div class="demo-image__preview" v-if="item.icon">
									<el-image style="width: 100%; height: 100%" :src="item.icon"
										:preview-src-list="titleSrcList"></el-image>
								</div>
								<p @click="setTitleUnfold($event)">展开文章</p>
							</div>
							<div class="answer-que-option">
								<div class="answer-que-option-title" v-show="item.text">{{item.title}}</div>
								<p v-if="multipleChoiceQuestions.includes(item.genre)"
									:class="{right:item.succ_res===answerOption[k],wrong:item.user_res===answerOption[k]}"
									v-for="(v,k) in item.option" :key="k">
									<em>{{answerOption[k]}}</em>
									<xmp>{{v}}</xmp>
								</p>
								<!-- 多选题start -->
								<p v-if="multipleChoicesQuestions.includes(item.genre)"
									:class="{right:item.right.includes(answerOption[k]),wrong:item.wrong.includes(answerOption[k]),cover:item.cover.includes(answerOption[k])}"
									v-for="(v,k) in item.option" :key="k">
									<em>{{answerOption[k]}}</em>
									<xmp>{{v}}</xmp>
								</p>
								<!-- 多选题end -->
								<!-- 填空题start -->
								<p v-if="fillInTheBlankQuestionType.includes(item.genre)" v-for="(v,k) in item.succ_res"
									:key="k">
									<em>{{k+1}}</em>
									<el-form :model="item">
										<el-form-item>
											<el-input v-model="item.succ_res[k]" placeholder="请输入答案"
												readonly="readonly"></el-input>
										</el-form-item>
									</el-form>
								</p>
								<!-- 填空题end -->
								<!-- 简答题start -->
								<p :class="{right:item.user_res==='会'}"
									v-show="shortAnswerQuestionType.includes(item.genre)" class="willnot"
									@click="meetingWillNot($event)">
									<em>?</em>
									<xmp>会</xmp>
								</p>
								<!-- 简答题end -->
								<p v-if="!(fillInTheBlankQuestionType.includes(item.genre))" class="willnot"
									:class="{wrong:item.user_res==='不会'}">
									<em>?</em>
									<xmp>不会</xmp>
								</p>
							</div>
							<div class="answer-que-option-btn" v-if="testType == '1' && testType == '2'">
								<el-button type="success">确认</el-button>
							</div>

							<!-- 解析 -->
							<div class="parsing" :class="{'parsing-show':showParsing == false}">
								<div class="parsing-title">
									<span>解析</span>
									<span>
										正确答案：
										<em>{{item.succ_res}}</em>
									</span>
									<span class="wrong">
										你的答案：
										<em>{{item.user_res}}</em>
									</span>
									<p>
										<button class="answer-title-wrong" @click="openWrongWin(item.id)">纠错</button>
										<button class="answer-title-parsing"
											@click="unfondParsing($event)">展开解析</button>
										<button class="answer-title-col" :class="{'col-active': item.favorite===1}"
											@click="setCollect(index)">收藏</button>
									</p>
								</div>
								<xmp>{{item.analysis}}</xmp>
							</div>

							<!-- 笔记 -->
							<div class="answer-note" hidden>
								<div class="parsing-title">本题笔记</div>
								<aside>
									<p>
										<el-input type="textarea" placeholder="请输入笔记内容" rows="3" v-model="noteValue"
											maxlength="200" show-word-limit >
										</el-input>
									</p>
									<el-button type="primary" size="small" @click="addnote(index)">保存</el-button>
								</aside>

								<div class="answer-note-list">
									<div class="note-list" v-for="note in item.note" :key="note.id">
										<div class="note-list-tit">
											<div class="note-list-photo">
												<el-avatar :size="50" :src="note.image"></el-avatar>
											</div>
											<div class="note-list-info">
												<p style="margin-top:4px">{{note.nickname}}</p>
												<p>{{note.create_time}}</p>
											</div>
											<button class="note-list-dete" v-if="note.uid == data.user_id" title="删除"
												@click="deleteNote(note.id,index)">删除</button>
											<!-- <button class="note-list-praise" v-else
												@click="praiseNote($event,note.id,index)">{{note.praise}}</button> -->
										</div>
										<div class="note-list-text"><pre>{{note.content}}</pre> </div>
									</div>
									<button class="answer-list-more" v-show="item.note && item.note.length>4"
										@click="loadMoreNotes(index)">加载更多笔记</button>
								</div>
							</div>
						</div>
						<el-dialog :visible.sync="showWrongWin" width="480px">
							<div class="win-wrong">
								<h3>纠错</h3>
								<el-form>
									<el-form-item>
										<el-input type="textarea" v-model="wrongValue" placeholder="请输入纠错内容"
											maxlength="200" show-word-limit></el-input>
									</el-form-item>
									<el-button type="primary" @click="errorCorrection()"
										style="margin:0;font-size: 16px;color: #fff;">确认</el-button>
								</el-form>
							</div>
						</el-dialog>
					</div>
				</div>
			</div>

			<div class="answer-box-right">
				<div class="result-right-title">
					<ol>
						<li>
							<p v-cloak>{{data.ranking}}</p>排名
						</li>
						<li>
							<p v-cloak>{{data.join}}</p>参与人数
						</li>
					</ol>
					<div class="result-pro">
						<p>
							<em>
								<b>{{data.success}}</b>%
							</em>正确率
						</p>
						<el-progress type="circle" :percentage="Number(data.success)==0.0?0.1:Number(data.success)"
							:width="130" :stroke-width="12" color="#e60012" :show-text="false"></el-progress>
					</div>
				</div>

				<div :class="{'result-fixed': scroll >= 250}">
					<!--答题卡-->
					<div class="answer-card">
						<h3>
							<img src="images/an_7.png" /> 答题卡
						</h3>
						<div class="card card-a">
							<el-button @click="slide(index+1,item.res)" v-for="(item,index) in parsing" :key="index"
								:class="{wrong:item.res===0,right:item.res===1}"
								v-show="index+1>=theSmallest && index+1<=maximum">{{index+1}}</el-button>
						</div>
						<p v-show="parsing.length>50">
							<el-form>
								<el-form-item>
									<el-select v-model="selectedValue" @change="quescount(selectedValue)">
										<el-option v-for="(item,index) in cardSelect" :key="index" :value="index"
											:label="item.label"></el-option>
									</el-select>
								</el-form-item>
							</el-form>
						</p>
					</div>

					<!--数据统计-->
					<div class="list-data" v-show="user_id !==''">
						<h3>
							<img src="/images/8.png" />数据统计
						</h3>
						<p>
							<router-link title="我的错题" to="/user/wrong">
								<img src="/images/10.png" />我的错题
								<em>{{statistics.error}}</em>
							</router-link>
						</p>
						<p>
							<router-link title="我的收藏" to="/user/collect">
								<img src="/images/11.png" />我的收藏
								<em>{{statistics.favorite}}</em>
							</router-link>
						</p>
						<p>
							<router-link title="我的笔记" to="/user/note">
								<img src="/images/12.png" />我的笔记
								<em>{{statistics.note}}</em>
							</router-link>
						</p>
					</div>
				</div>
			</div>

			<div class="clear"></div>
		</div>
	</div>
</template>


<script>
	import test from "../../../public/css/test.css";
	export default {
		name: "result-app",
		data() {
			return {
				result_id: 0,
				data: [],
				sub_id: 0,
				cate_id: 0,
				parsing: [],
				answerOption: ["A", "B", "C", "D", "E", "F", "G"],
				statistics: [],
				maximum: 50,
				theSmallest: 1,
				tab: true,
				numberOfNotes: 1,
				errorCorrectionId: 0,
				multipleChoiceQuestions: [
					1,
					3,
					4,
					5,
					7,
					8,
					9,
					1001,
					1003,
					1004,
					1101,
					1104,
					1201,
					1301,
					1304,
				], //单选题题型
				multipleChoicesQuestions: [2, 1002, 1102, 1302], //多选题题型
				fillInTheBlankQuestionType: [6, 1206], //填空题题型
				shortAnswerQuestionType: [4, 5, 7, 8, 9, 1004, 1104, 1304], //简答题题型
				bookFormatArray: ["jpg", "png", "jpeg", "ico", "gif"], //图片格式数组
				category_name: "",
				chapter: "",
				uid:'',
				chapter_sub: "",
				tabActive: "1",
				titleUrl: "",
				titleSrcList: ["/images/a2.png"],
				noteValue: "", //笔记文本框
				wrongValue: "", //纠错文本框
				noteList: [],
				cardSelect: [],
				selectedValue: "1",
				testType: "0", // 0单选 1多选 2填空 3阅读
				resultTitleHeight: "", //题干高度
				isUnfold: false, //是否展开
				setTitleText: "展开文章",
				showParsing: false, //显示解析
				showNote: false, //显示笔记
				showQueWin: false,
				showWrongWin: false,
				setParsingText: "展开解析",
				percent: 25,
				scroll: 0,
				types: 0,
			};
		},
		created() {
			
			this.result_id = this.$route.query.result_id;
			this.types = this.$route.query.type;
			if (this.$route.query.cate_id != undefined) {
				this.cate_id = this.$route.query.cate_id;
			} else {
				this.sub_id = this.$route.query.sub_id;
			}
			// //console.log(this.$route.query.cate_id);
			window.addEventListener("scroll", this.handleScroll);
			this.$loading(true);
			this.getInitialData();
		},
		filters: {
			formatDate: function(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? "0" + MM : MM;
				let d = date.getDate();
				d = d < 10 ? "0" + d : d;
				let h = date.getHours();
				h = h < 10 ? "0" + h : h;
				let m = date.getMinutes();
				m = m < 10 ? "0" + m : m;
				let s = date.getSeconds();
				s = s < 10 ? "0" + s : s;
				return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
			},
			forsecondDate: function(value) {
				if (value > 60) {
					let second = value % 60;
					let minute = parseInt(value / 60);
					if (minute > 60) {
						let hour = parseInt(minute / 60);
						minute = minute % 60;
						return hour + "时" + minute + "分" + second + "秒";
					} else {
						return minute + "分" + second + "秒";
					}
				} else {
					return value + "秒";
				}
			},
		},
		methods: {
			//转换数学公式
			mathJax() {
				let _this = this;
				setTimeout(function() {
					if (_this.commonsVariable.isMathjaxConfig) {
						//判断是否初始配置，若无则配置。
						_this.commonsVariable.initMathjaxConfig();
					}
					_this.commonsVariable.MathQueue("searchTextJson"); //传入组件id，让组件被MathJax渲染
				}, 500);
			},
			//获取初始数据
			getInitialData() {
				var param = {
					id: this.result_id,
					type: this.types
				};
				this.$api.getAnswerAnalysis(param).then(res => {
					this.parsing = res.data.info;
					// let error = this.parsing.filter(item => {
					// 	return item.
					// })
					// this.parsing = res.data.exam_res;
					// this.mathJax();
					this.$loading().close();
					//console.log(res)
					// setTimeout(() => {
					// 	this.$loading().close();
					// }, 500);
				})
				return
				this.$post("answerResult", param).then((res) => {
					//console.log(res.data);
					this.data = res.data;
					this.parsing = res.data.exam_res;
					this.mathJax();
					setTimeout(() => {
						this.$loading().close();
					}, 500);
				});
			},

			// 获取数据统计
			statistic() {
				var param = {
					uid: this.data.user_id,
				};
				this.$post("getPersonalData", param).then((res) => {
					this.statistics = res.data;
				});
			},

			//更换笔记
			changeNotes(index_) {
				var param = {
					sid: this.parsing[index_].id,
					page: 1,
				};
				this.$post("numberOfNotes", param).then((res) => {
					this.parsing[index_].note = res.data;
				});
			},
			//保存笔记
			addnote(index_) {
				if (this.user_id == "") {
					this.$message({
						type: "error",
						message: "请先登录！",
						showClose: true,
					});
					return;
				}
				var id = this.parsing[index_].id;
				var param = {
					gid: this.data.exam_id,
					sid: id,
					uid: this.data.user_id,
					content: this.noteValue,
				};
				this.$post("addnote", param).then((res) => {
					if (res.code == 200) {
						this.changeNotes(index_);
						this.$message({
							type: "success",
							message: "request succeeded！",
							showClose: true,
						});
						this.noteValue = ""; //清空输入框
						this.statistic();
					} else {
						this.$message({
							type: "error",
							message: "request failure！please try again later",
							showClose: true,
						});
					}
				});
			},
			//删除笔记
			deleteNote(id_, index_) {
				this.$confirm("您确定要删除笔记吗？", "删除", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(() => {
						this.$post("deletenote", {
							id: id_,
						}).then((res) => {
							if (res.code === 200) {
								this.changeNotes(index_);
								this.$message({
									type: "success",
									message: "删除成功！",
									showClose: true,
								});
								this.statistic();
							} else {
								this.$message({
									type: "error",
									message: "已取消！",
									showClose: true,
								});
							}
						});
					})
					.catch(() => {});
			},
			//加载更多笔记
			loadMoreNotes(index_) {
				this.numberOfNotes++;
				var sid = this.parsing[index_].id;
				var param = {
					sid: sid,
					page: this.numberOfNotes,
				};
				this.$post("numberOfNotes", param).then((res) => {
					if (res.code === 200) {
						this.data[index_].note = this.parsing[index_].note.concat(res.data);
					} else {
						this.$message({
							type: "error",
							message: "没有更多笔记了！",
							showClose: true,
						});
					}
				});
			},

			//获取题数数组
			questionsCount() {
				var param = {
					qid: this.data.exam_id,
				};
				this.$post("questionsCount", param).then((res) => {
					this.cardSelect = res.data;
				});
			},
			quescount(e) {
				var that = this;
				that.maximum = that.cardSelect[e].max;
				that.theSmallest = that.cardSelect[e].min;
			},

			tabSlide(index) {
				if (index === 1) {
					this.tab = true;
				} else {
					this.tab = false;
				}
				this.tabActive = index;
			},
			// 展开文章
			setTitleUnfold(e) {
				var that = e.currentTarget;
				$(that).prev().toggleClass("answer-que-title-xmp");
				if ($(that).prev().hasClass("answer-que-title-xmp")) {
					$(that).html("收起文章");
				} else {
					$(that).html("展开文章");
				}
			},
			// 查看答案解析
			seeParsing() {
				this.showParsing = true;
				this.showNote = true;
			},
			//纠错
			openWrongWin(id_) {
				this.showWrongWin = true;
				this.errorCorrectionId = id_;
			},
			//纠错
			errorCorrection() {
				if (this.user_id == "") {
					this.$message({
						type: "error",
						message: "请先登录！",
						showClose: true,
					});
					return;
				}
				var param = {
					uid: this.data.user_id,
					qid: this.errorCorrectionId,
					text: this.wrongValue,
				};
				this.$post("errorCorrection", param).then((res) => {
					if (res.code === 200) {
						this.$message({
							type: "success",
							message: "提交成功！感谢你的反馈，我们会在第一时间处理你的意见",
							showClose: true,
						});
						this.wrongValue = "";
					} else {
						this.$message({
							type: "error",
							message: "提交失败！请稍后重试",
							showClose: true,
						});
					}
					this.showWrongWin = false;
				});
			},

			//收藏
			setCollect(index_) {
				if (this.user_id == "") {
					this.$message({
						type: "error",
						message: "请先登录！",
						showClose: true,
					});
					return;
				}
				var id = this.parsing[index_].id;
				var favorite = this.parsing[index_].favorite;

				if (favorite == 0) {
					var param = {
						uid: this.data.user_id,
						tid: 4,
						gid: id,
						answer_id: this.parsing[index_].pid,
						create_time: Date.parse(new Date()) / 1000,
						update_time: Date.parse(new Date()) / 1000,
					};
					this.$post("addfavorite", param).then((res) => {
						if (res.code === 200) {
							this.$message({
								type: "success",
								message: "收藏成功!",
								showClose: true,
							});
							this.statistic();
						}
					});
					this.parsing[index_].favorite = 1;
				} else {
					//收藏过
					this.$confirm("是否要取消收藏？", "提示", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						})
						.then(() => {
							//点击确定
							var param = {
								uid: this.data.user_id,
								qid: id,
							};
							this.$post("deletefavorite", param).then((res) => {
								if (res.code === 200) {
									this.$message({
										type: "success",
										message: "删除成功!",
										showClose: true,
									});
									this.parsing[index_].favorite = 0;
									this.statistic();
								} else {
									this.$message({
										type: "success",
										message: "删除失败，请稍后重试!",
										showClose: true,
									});
								}
							});
						})
						.catch(() => {});
				}
			},
			//点赞笔记
			// praiseNote(e, id_, index_) {
			// 		this.$api.userNotePraise({id:id}).then((res)=>{
			// 						this.viewResolution(id,'u')})
			// },
			//顶部面包屑
			cateCrumbs() {
				var param = {
					sub_id: this.sub_id,
				};
				this.$post("cateCrumbs", param).then((res) => {
					this.category_name = res.data.nname;
					this.chapter = res.data.cname;
					this.chapter_sub = res.data.name;
				});
			},
			unfondParsing(e) {
				var that = e.currentTarget;
				$(that).parents(".parsing").toggleClass("parsing-show");
				$(that).parents(".parsing").next().toggle();

				if ($(that).parents(".parsing").hasClass("parsing-show")) {
					$(that).html("展开解析");
				} else {
					$(that).html("收起解析");
				}
			},
			//页面滚动
			handleScroll() {
				this.scroll =
					document.documentElement.scrollTop || document.body.scrollTop;
			},
			goBack() {
				this.$router.push({
					path: "/",
				});
			},
			setHeight() {
				// this.titleHeight = this.$refs["resultTitleHeight"];
				$(".result-xmp").each(function() {
					if ($(this).height() >= 121) {
						$(this).parents(".answer-que").addClass("answer-word");
					}
				});
			},
		},
		destroyed() {
			window.removeEventListener("scroll", this.handleScroll);
			window.removeEventListener("popstate", this.goBack, false);
		},
		mounted() {
			if (window.history && window.history.pushState) {
				// 向历史记录中插入了当前页
				history.pushState(null, null, document.URL);
				window.addEventListener("popstate", this.goBack, false);
			}
		},
		watch: {
			data: function() {
				this.$nextTick(() => {
					this.questionsCount();
					this.statistic();
					this.setHeight();
				});
			},
			sub_id: function() {
				this.$nextTick(() => {
					this.cateCrumbs();
				});
			},
		},
	};
</script>

<style>
	.result-app .answer-box-left {
		background: none;
		width: 900px;
		padding: 0 0 30px 0;
	}

	.detail-nav {
		width: auto;
		padding: 20px 30px;
		border-bottom: 1px solid #f5f5f5;
	}

	.el-dialog {
		border-radius: 10px !important;
	}

	.result-app .answer-que-option p:active {
		background: none;
	}

	.result-app .answer-gap .answer-que-option .willnot:active {
		background: none;
	}

	.list-data {
		background: #fff;
		margin: 20px auto auto auto;
	}

	.list-data img {
		margin-right: 5px;
		position: relative;
		top: -2px;
		height: 16px;
	}

	.list-data h3 {
		height: 60px;
		line-height: 60px;
		font-size: 16px;
		padding: 0 20px;
	}

	.list-data p a {
		display: block;
		height: 60px;
		line-height: 60px;
		padding: 0 20px;
		color: #999;
		border-top: 1px solid #ebebeb;
	}

	.list-data p a:hover {
		color: #e60012;
	}

	.list-data p a em {
		float: right;
		color: #e60012;
		font-weight: bold;
	}

	.result-fixed {
		position: fixed;
		width: 280px;
		top: 0;
	}

	.result-test .parsing {
		border-bottom: none;
	}

	.result-test .parsing xmp {
		padding: 30px;
	}

	.result-test .answer-note {
		margin-top: 0;
		border: 1px solid #f5f5f5;
		padding: 30px;
		border-top: none;
	}

	.result-test .answer-note .parsing-title {
		position: relative;
	}

	.result-test .answer-note .parsing-title::before {
		content: "";
		display: block;
		width: 100%;
		border-top: 1px dashed #f5f5f5;
		position: absolute;
		top: -30px;
		left: 0;
	}

	.result-test .answer-word .answer-que-option {
		border-radius: 10px;
	}

	.result-app .answer-box {
		margin-top: 0;
	}
</style>
